import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { input: String }

  connect() {
    if (this.hasInputTarget) {
      this.originalValue = this.inputTarget.value
    }

    const input = this.resolveInput()
    if (input) {
      this.boundUpdateFilled = this.updateFilled.bind(this, input)
      this.boundUpdateFilled()
      input.addEventListener('change', this.boundUpdateFilled)
      input.addEventListener('input', this.boundUpdateFilled)
    }
  }

  disconnect() {
    const input = this.resolveInput()
    if (input && this.boundUpdateFilled) {
      input.removeEventListener('change', this.boundUpdateFilled)
      input.removeEventListener('input', this.boundUpdateFilled)
    }
  }

  resolveInput() {
    if (this.hasInputTarget) return this.inputTarget
    if (this.inputValue) return document.getElementById(this.inputValue)
    return null
  }

  updateFilled(input) {
    input.classList.toggle('has-value', Boolean(input.value))
  }

  submit() {
    if (!this.hasInputTarget) return

    const current = this.inputTarget.value

    if (!current) return

    if (current === this.originalValue) return

    this.originalValue = current
    this.element.requestSubmit()
  }

  open(event) {
    if (event) event.preventDefault()
    if (!this.hasInputTarget) return

    const input = this.inputTarget

    try { input.focus({ preventScroll: true }) } catch(_) { input.focus() }

    if (typeof input.showPicker === 'function') {
      input.showPicker()
      return
    }

    input.click()
  }

  openPicker() {
    const input = document.getElementById(this.inputValue)
    if (input && input.showPicker) {
      input.showPicker()
    } else if (input) {
      // Fallback for browsers that don't support showPicker()
      input.focus()
      input.click()
    }
  }
}
